import React from 'react';
import CellAbstract from './CellAbstract';
import classNames from 'classnames';
import { isFunction, isString } from 'lodash';
import { CELL_COUNT_PROPS } from './Types';

class CellCount extends CellAbstract<CELL_COUNT_PROPS, {}> {
  render() {
    const {
      cellConfig = {},
      dataIndex,
      dataItem,
      field
    } = this.props;
    const value = dataItem[(field || dataIndex)];
    let { tooltip, getText, getTooltip } = cellConfig;
    const isPositive = value > 0;

    tooltip = isFunction(getTooltip) ? getTooltip(value, dataItem) : tooltip;
    const title = tooltip ? (isString(tooltip) ? tooltip : tooltip?.title) : undefined;
    const text = isFunction(getText) ? getText(value, dataItem) : (Array.isArray(value) ? value.length : value);
    const className = classNames({
      'tp-color-link': isPositive
    });

    const cmp = (
      <span
        tabIndex={title ? 0 : -1}
        className={`${isPositive ? 'tp-cell-type-count' : 'tp-cell-type-count-zero'} ${className}`}
        title={title}
      >
        {text}
      </span>
    );

    return this.renderCell(cmp, tooltip);
  }
}

export default CellCount;
